import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfileVideoListRequest } from '@/shared/api/requests/video/club-video-list/request';
import { getClubProfileVideoList } from '@/shared/api/requests/video/club-video-list/request';

export const useClubProfileVideoListQuery = (
  params: GetClubProfileVideoListRequest,
  settings?: QuerySettings<typeof getClubProfileVideoList>
) =>
  useQuery({
    queryKey: ['ClubProfileVideoList', params.profileId],
    queryFn: () =>
      getClubProfileVideoList({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
